export default __webpack_public_path__ + "static/media/home-solid.b9304e90.svg";